export interface FuzzyDate {
  date: string;
  precision: string;
}

export const emptyFuzzyDate: FuzzyDate = { date: '', precision: '' };